import template from './reports.html';
import controller from './reports.controller';

let reportsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default reportsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/reports.component.js